export default "__VITE_ASSET__DlpB0T0u__"